/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lp_Login_Operationstitle1Inputs */

const en_lp_login_operationstitle1 = /** @type {(inputs: Lp_Login_Operationstitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facilitate operations`)
};

/**
* | output |
* | --- |
* | "Facilitate operations" |
*
* @param {Lp_Login_Operationstitle1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const lp_login_operationstitle1 = /** @type {((inputs?: Lp_Login_Operationstitle1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lp_Login_Operationstitle1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_lp_login_operationstitle1(inputs)
});
export { lp_login_operationstitle1 as "lp_login_operationsTitle" }